// Generated by scripts/build-brand-display-assets.mjs.
export const bundledBrandNames: readonly string[] = [
  "100 Plus",
  "3M Scotch-Brite",
  "7Days",
  "7UP",
  "888",
  "A Plus",
  "A&W",
  "A1",
  "Adabi",
  "Aik Cheong",
  "Ajax",
  "Aji-Nazri",
  "Ajinomoto",
  "Alfredo",
  "Alkamax",
  "Alladdin",
  "Anchor",
  "Anglia",
  "Anlene",
  "Anmum",
  "Antabax",
  "Apollo",
  "Appeton",
  "Arm & Hammer",
  "Axion",
  "Ayam Brand",
  "Ayataka",
  "Babas",
  "Baker's Choice",
  "Balducci",
  "Basso",
  "Baygon",
  "Besila",
  "Bin Bin",
  "Bio Zip",
  "Blaze",
  "Boh",
  "Brand not stated",
  "BRAND'S",
  "Breeze",
  "Bundaberg",
  "Buruh",
  "Cadbury",
  "Campbells",
  "Cap Bintang",
  "Cap Bunga",
  "Cap Burung",
  "Cap Gasing",
  "Cap Jagung",
  "Cap Kapak",
  "Cap Kapal ABC",
  "Cap Rumah",
  "Cap Sauh",
  "Cap Teratai",
  "Captain",
  "Caress",
  "Carlsberg",
  "Carnation",
  "Carrie Family",
  "Carrie J",
  "Catsco",
  "Certainty",
  "Chandrika",
  "Cheezels",
  "Chipsmore",
  "Cif",
  "Cili",
  "Clear",
  "Clorox",
  "Coca-Cola",
  "Cocoaland",
  "Colgate",
  "Connor's",
  "Cutie",
  "Daia",
  "Daily Max",
  "Dairy Champ",
  "Dapurdeli",
  "Darlie",
  "Dasani",
  "Dashing",
  "De Choice",
  "Desa",
  "Dettol",
  "Doublemint",
  "Dove",
  "Dr P",
  "Drinho",
  "Drypers",
  "Duchef",
  "Dumex",
  "Dutch Lady",
  "Eagle",
  "Enchanteur",
  "Energizer",
  "Erawan Brand",
  "Ever Delicious",
  "Eveready",
  "Eversoft",
  "F-Clean",
  "F&N",
  "F&N Magnolia",
  "F&N Seasons",
  "Fanta",
  "Febreze",
  "Felix",
  "Ferrero Rocher",
  "Fisherman's Friend",
  "Follow Me",
  "Fresh White",
  "Friskies",
  "Fumakilla",
  "FYP",
  "Garnier",
  "Gatsby",
  "Gillette",
  "Ginvera",
  "Glico Pocky",
  "Glo",
  "Glow & Lovely",
  "Gold Coin",
  "Goodday",
  "Guinness",
  "Head & Shoulders",
  "Heineken",
  "Hero",
  "Himalaya Salt Sports",
  "Hogomas",
  "Holiday On Ice",
  "Horlicks",
  "Huggies",
  "Hup Seng",
  "Hwa Tai",
  "Indocafe",
  "Indomie",
  "Jack N Jill",
  "Jalen",
  "Jeram",
  "Juicy Fruit",
  "Julie's",
  "KCA",
  "Kellogg's",
  "Kewpie",
  "Kimball",
  "Kinder Bueno",
  "Kipas Udang",
  "KitKat",
  "Kleenex",
  "Knife",
  "Koolfever",
  "Kotex",
  "Kronenbourg",
  "Labour",
  "Lady's Choice",
  "Lays",
  "Levalsh",
  "Libresse",
  "Life",
  "Lifebuoy",
  "Lipton",
  "Maggi",
  "Mahsuri",
  "Mamee",
  "Marigold",
  "Mi Sedaap",
  "Midea",
  "Milo",
  "Misha",
  "Mission",
  "Mister Potato",
  "Moccona",
  "Nescafé",
  "Nestle",
  "Nivea",
  "Nongshim",
  "Nutella",
  "OldTown",
  "Onward",
  "Onwards",
  "Oriental Super Ring",
  "Pantene",
  "Pedigree",
  "Planta",
  "Popo",
  "Prego",
  "Premier",
  "Probalance",
  "Prodiet",
  "Puteri",
  "Red Eagle",
  "Rexona",
  "Ridsect",
  "Royal Stout",
  "Safi",
  "Saji",
  "Salonpas",
  "Sapporo",
  "Seri Murni",
  "Seri Pelangi",
  "Shieldtox",
  "Skol",
  "SmartHeart",
  "Soyfresh",
  "Sunsilk",
  "Sunsweet",
  "Tai Sun",
  "Tao Kae Noi",
  "Thumbs",
  "Tiger",
  "Tong Garden",
  "Twisties",
  "Vaseline",
  "Whiskas",
  "Wise Cottage",
  "Yeo's"
];

export const bundledBrandImages: Record<string, string> = {
  "888": "/brand-images/generated/888.png",
  "100 plus": "/brand-images/generated/100-plus.png",
  "3m scotch-brite": "/brand-images/generated/3m-scotch-brite.png",
  "7days": "/brand-images/generated/7days.png",
  "7up": "/brand-images/generated/7up.png",
  "a plus": "/brand-images/generated/a-plus.png",
  "a&w": "/brand-images/generated/a-w.png",
  "a1": "/brand-images/generated/a1.png",
  "adabi": "/brand-images/generated/adabi.png",
  "aik cheong": "/brand-images/generated/aik-cheong.png",
  "ajax": "/brand-images/generated/ajax.png",
  "aji-nazri": "/brand-images/generated/aji-nazri.png",
  "ajinomoto": "/brand-images/generated/ajinomoto.png",
  "alfredo": "/brand-images/generated/alfredo.png",
  "alkamax": "/brand-images/generated/alkamax.png",
  "alladdin": "/brand-images/generated/alladdin.png",
  "anchor": "/brand-images/generated/anchor.png",
  "anglia": "/brand-images/generated/anglia.png",
  "anlene": "/brand-images/generated/anlene.png",
  "anmum": "/brand-images/generated/anmum.png",
  "antabax": "/brand-images/generated/antabax.png",
  "apollo": "/brand-images/generated/apollo.png",
  "appeton": "/brand-images/generated/appeton.png",
  "arm & hammer": "/brand-images/generated/arm-hammer.png",
  "axion": "/brand-images/generated/axion.png",
  "ayam brand": "/brand-images/generated/ayam-brand.png",
  "ayataka": "/brand-images/generated/ayataka.png",
  "babas": "/brand-images/generated/babas.png",
  "baker's choice": "/brand-images/generated/baker-s-choice.png",
  "balducci": "/brand-images/generated/balducci.png",
  "basso": "/brand-images/generated/basso.png",
  "baygon": "/brand-images/generated/baygon.png",
  "besila": "/brand-images/generated/besila.png",
  "bin bin": "/brand-images/generated/bin-bin.png",
  "bio zip": "/brand-images/generated/bio-zip.png",
  "blaze": "/brand-images/generated/blaze.png",
  "boh": "/brand-images/generated/boh.png",
  "brand not stated": "/brand-images/generated/brand-not-stated.png",
  "brand's": "/brand-images/generated/brand-s.png",
  "breeze": "/brand-images/generated/breeze.png",
  "bundaberg": "/brand-images/generated/bundaberg.png",
  "buruh": "/brand-images/generated/buruh.png",
  "cadbury": "/brand-images/generated/cadbury.png",
  "campbells": "/brand-images/generated/campbells.png",
  "cap bintang": "/brand-images/generated/cap-bintang.png",
  "cap bunga": "/brand-images/generated/cap-bunga.png",
  "cap burung": "/brand-images/generated/cap-burung.png",
  "cap gasing": "/brand-images/generated/cap-gasing.png",
  "cap jagung": "/brand-images/generated/cap-jagung.png",
  "cap kapak": "/brand-images/generated/cap-kapak.png",
  "cap kapal abc": "/brand-images/generated/cap-kapal-abc.png",
  "cap rumah": "/brand-images/generated/cap-rumah.png",
  "cap sauh": "/brand-images/generated/cap-sauh.png",
  "cap teratai": "/brand-images/generated/cap-teratai.png",
  "captain": "/brand-images/generated/captain.png",
  "caress": "/brand-images/generated/caress.png",
  "carlsberg": "/brand-images/generated/carlsberg.png",
  "carnation": "/brand-images/generated/carnation.png",
  "carrie family": "/brand-images/generated/carrie-family.png",
  "carrie j": "/brand-images/generated/carrie-j.png",
  "catsco": "/brand-images/generated/catsco.png",
  "certainty": "/brand-images/generated/certainty.png",
  "chandrika": "/brand-images/generated/chandrika.png",
  "cheezels": "/brand-images/generated/cheezels.png",
  "chipsmore": "/brand-images/generated/chipsmore.png",
  "cif": "/brand-images/generated/cif.png",
  "cili": "/brand-images/generated/cili.png",
  "clear": "/brand-images/generated/clear.png",
  "clorox": "/brand-images/generated/clorox.png",
  "coca-cola": "/brand-images/generated/coca-cola.png",
  "cocoaland": "/brand-images/generated/cocoaland.png",
  "colgate": "/brand-images/generated/colgate.png",
  "connor's": "/brand-images/generated/connor-s.png",
  "cutie": "/brand-images/generated/cutie.png",
  "daia": "/brand-images/generated/daia.png",
  "daily max": "/brand-images/generated/daily-max.png",
  "dairy champ": "/brand-images/generated/dairy-champ.png",
  "dapurdeli": "/brand-images/generated/dapurdeli.png",
  "darlie": "/brand-images/generated/darlie.png",
  "dasani": "/brand-images/generated/dasani.png",
  "dashing": "/brand-images/generated/dashing.png",
  "de choice": "/brand-images/generated/de-choice.png",
  "desa": "/brand-images/generated/desa.png",
  "dettol": "/brand-images/generated/dettol.png",
  "doublemint": "/brand-images/generated/doublemint.png",
  "dove": "/brand-images/generated/dove.png",
  "dr p": "/brand-images/generated/dr-p.png",
  "drinho": "/brand-images/generated/drinho.png",
  "drypers": "/brand-images/generated/drypers.png",
  "duchef": "/brand-images/generated/duchef.png",
  "dumex": "/brand-images/generated/dumex.png",
  "dutch lady": "/brand-images/generated/dutch-lady.png",
  "eagle": "/brand-images/generated/eagle.png",
  "enchanteur": "/brand-images/generated/enchanteur.png",
  "energizer": "/brand-images/generated/energizer.png",
  "erawan brand": "/brand-images/generated/erawan-brand.png",
  "ever delicious": "/brand-images/generated/ever-delicious.png",
  "eveready": "/brand-images/generated/eveready.png",
  "eversoft": "/brand-images/generated/eversoft.png",
  "f-clean": "/brand-images/generated/f-clean.png",
  "f&n": "/brand-images/generated/f-n.png",
  "f&n magnolia": "/brand-images/generated/f-n-magnolia.png",
  "f&n seasons": "/brand-images/generated/f-n-seasons.png",
  "fanta": "/brand-images/generated/fanta.png",
  "febreze": "/brand-images/generated/febreze.png",
  "felix": "/brand-images/generated/felix.png",
  "ferrero rocher": "/brand-images/generated/ferrero-rocher.png",
  "fisherman's friend": "/brand-images/generated/fisherman-s-friend.png",
  "follow me": "/brand-images/generated/follow-me.png",
  "fresh white": "/brand-images/generated/fresh-white.png",
  "friskies": "/brand-images/generated/friskies.png",
  "fumakilla": "/brand-images/generated/fumakilla.png",
  "fyp": "/brand-images/generated/fyp.png",
  "garnier": "/brand-images/generated/garnier.png",
  "gatsby": "/brand-images/generated/gatsby.png",
  "gillette": "/brand-images/generated/gillette.png",
  "ginvera": "/brand-images/generated/ginvera.png",
  "glico pocky": "/brand-images/generated/glico-pocky.png",
  "glo": "/brand-images/generated/glo.png",
  "glow & lovely": "/brand-images/generated/glow-lovely.png",
  "gold coin": "/brand-images/generated/gold-coin.png",
  "goodday": "/brand-images/generated/goodday.png",
  "guinness": "/brand-images/generated/guinness.png",
  "head & shoulders": "/brand-images/generated/head-shoulders.png",
  "heineken": "/brand-images/generated/heineken.png",
  "hero": "/brand-images/generated/hero.png",
  "himalaya salt sports": "/brand-images/generated/himalaya-salt-sports.png",
  "hogomas": "/brand-images/generated/hogomas.png",
  "holiday on ice": "/brand-images/generated/holiday-on-ice.png",
  "horlicks": "/brand-images/generated/horlicks.png",
  "huggies": "/brand-images/generated/huggies.png",
  "hup seng": "/brand-images/generated/hup-seng.png",
  "hwa tai": "/brand-images/generated/hwa-tai.png",
  "indocafe": "/brand-images/generated/indocafe.png",
  "indomie": "/brand-images/generated/indomie.png",
  "jack n jill": "/brand-images/generated/jack-n-jill.png",
  "jalen": "/brand-images/generated/jalen.png",
  "jeram": "/brand-images/generated/jeram.png",
  "juicy fruit": "/brand-images/generated/juicy-fruit.png",
  "julie's": "/brand-images/generated/julie-s.png",
  "kca": "/brand-images/generated/kca.png",
  "kellogg's": "/brand-images/generated/kellogg-s.png",
  "kewpie": "/brand-images/generated/kewpie.png",
  "kimball": "/brand-images/generated/kimball.png",
  "kinder bueno": "/brand-images/generated/kinder-bueno.png",
  "kipas udang": "/brand-images/generated/kipas-udang.png",
  "kitkat": "/brand-images/generated/kitkat.png",
  "kleenex": "/brand-images/generated/kleenex.png",
  "knife": "/brand-images/generated/knife.png",
  "koolfever": "/brand-images/generated/koolfever.png",
  "kotex": "/brand-images/generated/kotex.png",
  "kronenbourg": "/brand-images/generated/kronenbourg.png",
  "labour": "/brand-images/generated/labour.png",
  "lady's choice": "/brand-images/generated/lady-s-choice.png",
  "lays": "/brand-images/generated/lays.png",
  "levalsh": "/brand-images/generated/levalsh.png",
  "libresse": "/brand-images/generated/libresse.png",
  "life": "/brand-images/generated/life.png",
  "lifebuoy": "/brand-images/generated/lifebuoy.png",
  "lipton": "/brand-images/generated/lipton.png",
  "maggi": "/brand-images/generated/maggi.png",
  "mahsuri": "/brand-images/generated/mahsuri.png",
  "mamee": "/brand-images/generated/mamee.png",
  "marigold": "/brand-images/generated/marigold.png",
  "mi sedaap": "/brand-images/generated/mi-sedaap.png",
  "midea": "/brand-images/generated/midea.png",
  "milo": "/brand-images/generated/milo.png",
  "misha": "/brand-images/generated/misha.png",
  "mission": "/brand-images/generated/mission.png",
  "mister potato": "/brand-images/generated/mister-potato.png",
  "moccona": "/brand-images/generated/moccona.png",
  "nescafé": "/brand-images/generated/nescafe.png",
  "nestle": "/brand-images/generated/nestle.png",
  "nivea": "/brand-images/generated/nivea.png",
  "nongshim": "/brand-images/generated/nongshim.png",
  "nutella": "/brand-images/generated/nutella.png",
  "oldtown": "/brand-images/generated/oldtown.png",
  "onward": "/brand-images/generated/onward.png",
  "onwards": "/brand-images/generated/onwards.png",
  "oriental super ring": "/brand-images/generated/oriental-super-ring.png",
  "pantene": "/brand-images/generated/pantene.png",
  "pedigree": "/brand-images/generated/pedigree.png",
  "planta": "/brand-images/generated/planta.png",
  "popo": "/brand-images/generated/popo.png",
  "prego": "/brand-images/generated/prego.png",
  "premier": "/brand-images/generated/premier.png",
  "probalance": "/brand-images/generated/probalance.png",
  "prodiet": "/brand-images/generated/prodiet.png",
  "puteri": "/brand-images/generated/puteri.png",
  "red eagle": "/brand-images/generated/red-eagle.png",
  "rexona": "/brand-images/generated/rexona.png",
  "ridsect": "/brand-images/generated/ridsect.png",
  "royal stout": "/brand-images/generated/royal-stout.png",
  "safi": "/brand-images/generated/safi.png",
  "saji": "/brand-images/generated/saji.png",
  "salonpas": "/brand-images/generated/salonpas.png",
  "sapporo": "/brand-images/generated/sapporo.png",
  "seri murni": "/brand-images/generated/seri-murni.png",
  "seri pelangi": "/brand-images/generated/seri-pelangi.png",
  "shieldtox": "/brand-images/generated/shieldtox.png",
  "skol": "/brand-images/generated/skol.png",
  "smartheart": "/brand-images/generated/smartheart.png",
  "soyfresh": "/brand-images/generated/soyfresh.png",
  "sunsilk": "/brand-images/generated/sunsilk.png",
  "sunsweet": "/brand-images/generated/sunsweet.png",
  "tai sun": "/brand-images/generated/tai-sun.png",
  "tao kae noi": "/brand-images/generated/tao-kae-noi.png",
  "thumbs": "/brand-images/generated/thumbs.png",
  "tiger": "/brand-images/generated/tiger.png",
  "tong garden": "/brand-images/generated/tong-garden.png",
  "twisties": "/brand-images/generated/twisties.png",
  "vaseline": "/brand-images/generated/vaseline.png",
  "whiskas": "/brand-images/generated/whiskas.png",
  "wise cottage": "/brand-images/generated/wise-cottage.png",
  "yeo's": "/brand-images/generated/yeo-s.png"
};
